'use client';

import { useWatch } from 'react-hook-form';
import DescriptionActionAfterIncidentInput from '../../../../../components/HookFormComponents/Inputs/DescriptionActionAfterIncident';
import DescriptionIncidentInput from '../../../../../components/HookFormComponents/Inputs/DescriptionIncident';
import NotificationCategoryInput from '../../../../../components/HookFormComponents/Inputs/NotificationCategory';
import NotificationIncidentInput from '../../../../../components/HookFormComponents/Inputs/NotificationIncident';
import NotificationOptionInput from '../../../../../components/HookFormComponents/Inputs/NotificationOption';
import NotificationTypeInput from '../../../../../components/HookFormComponents/Inputs/NotificationType';
import NotificationUploadFiles from '../../../../../components/HookFormComponents/Inputs/NotificationUploadFiles';
import PatientOrFamilyKnow from '../../../../../components/HookFormComponents/Inputs/PatientOrFamilyKnow';
import QualityDeviationsInputs from '../../../../../components/HookFormComponents/Inputs/QualityDeviations';
import QuestionsAnswers from '../../../../../components/HookFormComponents/Inputs/QuestionsAnswers';
import SignalingSocialMediaByFamily from '../../../../../components/HookFormComponents/Inputs/SignalingSocialMediaByFamily';
import ThereWasNegativeDemonstration from '../../../../../components/HookFormComponents/Inputs/ThereWasNegativeDemonstration';
import WhoWasNotifiedInput from '../../../../../components/HookFormComponents/Inputs/WhoWasNotified';
import { EpStepContent } from '../../../../../components/HookFormComponents/components';
import { useTranslation as t } from '../../../../../hooks/useTranslation';
import { globalizationService } from '../../../../../services/globalizationService';
import styles from './steps.module.scss';
import { useBundles } from '../../../../../hooks/useBundles';

export default function Step3IncidentNotification() {
  const tag = 'PSNotificationHow';
  const [notificationTypeId, NotificationCategory] = useWatch({
    name: ['notificationTypeId.inputValue', 'notificationCategoryId.inputValue'],
  });
  const { translations } = globalizationService.getTranslationsByTag(tag);

  const hasStandardBundle = useBundles(Number(process.env.NEXT_PUBLIC_BUNDLES_STANDARD));

  return (
    <div className={styles['step3']}>
      <EpStepContent.Card
        title={t(translations, 'In your opinion, what happened?')}
      >
        <NotificationTypeInput translations={translations} />

        <div className={styles['step3']}>
          <NotificationCategoryInput translations={translations} />

          <NotificationIncidentInput translations={translations} />

          <NotificationOptionInput translations={translations} />
        </div>
      </EpStepContent.Card>

      <EpStepContent.Card
        visible={notificationTypeId !== undefined}
        title={t(translations, 'About the incident')}
      >

        {NotificationCategory !== '45' && (
          <QuestionsAnswers />
        )}

        <QualityDeviationsInputs />

        <DescriptionIncidentInput translations={translations} />

        <DescriptionActionAfterIncidentInput translations={translations} />
      </EpStepContent.Card>

      <EpStepContent.Card
        visible={notificationTypeId !== undefined}
        title={t(translations, 'Who witnessed or was informed?')}
      >
        <PatientOrFamilyKnow translations={translations} />

        <ThereWasNegativeDemonstration translations={translations} />

        <SignalingSocialMediaByFamily translations={translations} />

        <WhoWasNotifiedInput translations={translations} />
      </EpStepContent.Card>

      {!!hasStandardBundle && (
        <EpStepContent.Card
          visible={notificationTypeId !== undefined}
          title={t(
            translations,
            'Do you want to attach files to this notification? (optional)',
          )}
        >
          <NotificationUploadFiles translations={translations} />
        </EpStepContent.Card>
      )}
    </div>
  );
}
